// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import * as Flags from '../../assets/img/flags';
import { getPrivateIconUrl } from '../../config/urls';

const Icon = styled.div`
  height: 1.3em;
  width: 1.3em;
  border-radius: 0.3em;
  background-image: ${({ $imgPath }) => `url(${$imgPath})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
`;

type PropsType = {
  className?: string;
  flagId: string;
};

const FlagIcon = ({ className, flagId }: PropsType) => {
  const imgPath = useMemo(() => {
    let result = Flags[flagId?.toLowerCase()];

    if (!result) {
      result = getPrivateIconUrl(flagId);
    }
    return result;
  }, [flagId]);

  return <Icon className={className} $imgPath={imgPath} />;
};

export default FlagIcon;
